module.exports = __webpack_public_path__ + "static/media/elements_section3.17f72a40.png";